import { useEffect, useRef, useState } from "react";

const ZOOM_STEP = 0.25;
export const ZOOM_MIN = 0.5;
export const ZOOM_MAX = 3;

export const useZoomAndPan = (dependency?: unknown) => {
  const [scale, setScale] = useState(1);
  const [isDragging, setIsDragging] = useState(false);

  const scrollRef = useRef<HTMLDivElement>(null);
  const isDraggingRef = useRef(false);
  const dragOrigin = useRef<{ x: number; y: number; scrollLeft: number; scrollTop: number } | null>(null);

  // Reset state when dependency changes (e.g., navigating between files)
  useEffect(() => {
    setScale(1);
  }, [dependency]);

  const zoomIn = () => setScale((s) => Math.min(s + ZOOM_STEP, ZOOM_MAX));
  const zoomOut = () => setScale((s) => Math.max(s - ZOOM_STEP, ZOOM_MIN));

  const onMouseDown = (e: React.MouseEvent<HTMLDivElement>) => {
    const el = scrollRef.current;
    if (!el) return;
    isDraggingRef.current = true;
    setIsDragging(true);
    dragOrigin.current = { x: e.clientX, y: e.clientY, scrollLeft: el.scrollLeft, scrollTop: el.scrollTop };
    e.preventDefault();
  };

  const onMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!isDraggingRef.current || !dragOrigin.current || !scrollRef.current) return;
    const dx = e.clientX - dragOrigin.current.x;
    const dy = e.clientY - dragOrigin.current.y;
    scrollRef.current.scrollLeft = dragOrigin.current.scrollLeft - dx;
    scrollRef.current.scrollTop = dragOrigin.current.scrollTop - dy;
  };

  const onMouseUp = () => {
    isDraggingRef.current = false;
    setIsDragging(false);
    dragOrigin.current = null;
  };

  return {
    scale,
    isDragging,
    scrollRef,
    zoomIn,
    zoomOut,
    onMouseDown,
    onMouseMove,
    onMouseUp,
  };
};
